import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { BottoneIcona } from './base.tsx'
import { IconaChiudi, IconaLucchetto } from './Icone.tsx'

/**
 * Riga del secondo fattore sopra la pagina, per chi non l'ha attivato. Porta a «Secondo fattore», non
 * blocca niente, si chiude con la crocetta e torna all'accesso dopo, o ricaricando la pagina: il ricordo
 * sta solo nel componente, che l'impalcatura monta a ogni ingresso.
 *
 * Due forme:
 * - invito (decisione di Davide del 31/10/2026 sera, 496): il secondo fattore e' facoltativo e la riga
 *   lo propone, in tono discreto come l'avviso delle novita';
 * - periodo di grazia (493), se per un ruolo si rimette un obbligo con la sua data: la riga dice entro
 *   quando, in tono di attenzione.
 */
export function AvvisoSecondoFattore() {
  const { io } = useSessione()
  const { pathname } = useLocation()
  const [chiuso, setChiuso] = useState(false)
  const stato = io?.secondoFattore
  const entro = stato?.daAttivareEntro
  if (!stato || !(entro || stato.consigliato) || chiuso || pathname === '/secondo-fattore') return null

  // «16/11»: giorno e mese bastano, la grazia dura poche settimane.
  const giorno = entro?.split('-').slice(1).reverse().join('/')
  return (
    <div className={entro ? 'fattore-avviso' : 'fattore-avviso invito'} role="status">
      <IconaLucchetto />
      {entro ? (
        <p>
          <strong>Attiva il secondo fattore entro il {giorno}</strong>: dal giorno dopo, senza, il gestionale non
          si apre. <Link to="/secondo-fattore">Attivalo adesso</Link>
        </p>
      ) : (
        <p>
          <strong>Proteggi il tuo accesso</strong> con il secondo fattore: un codice dal telefono oltre alla
          password. <Link to="/secondo-fattore">Attivalo</Link>
        </p>
      )}
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi l’avviso del secondo fattore"
                    onClick={() => setChiuso(true)} />
    </div>
  )
}
